import React, { useState, useEffect } from 'react';
import { Tooltip, Typography, Dropdown, Menu, message } from 'antd';

interface LinkAlertProps {
    url: string;
    onDelete?: () => void;
}

const LinkAlert = ({ url, onDelete }: LinkAlertProps) => {
    const [favicon, setFavicon] = useState('');
    const [title, setTitle] = useState('');

    const getDomain = (url: string) => {
        try {
            const { hostname } = new URL(url);
            return hostname;
        }
        catch {
            return url;
        }
    };

    useEffect(() => {
        const domain = getDomain(url);
        const faviconUrl = `https://icons.duckduckgo.com/ip3/${domain}.ico`;
        setFavicon(faviconUrl);
        setTitle(getDomain(url));
    }, [url]);

    const items = [
        {
            key: 'open',
            label: (<a href={url} target="_blank" rel="noopener noreferrer">
                Открыть в новой вкладке
            </a>),
        },
        {
            key: 'copy',
            onClick: () => {
                navigator.clipboard.writeText(url);
                message.success('Ссылка скопирована!');
            },
            label: 'Копировать ссылку',
        },
    ];

    if (onDelete) {
        items.push({
            key: 'delete',
            label: 'Удалить',
            onClick: onDelete,
        });
    }

    return (
        <div onContextMenu={(e) => e.stopPropagation()}>
            <Dropdown menu={{ items }} trigger={['contextMenu']}>
                <Tooltip title={title}>
                    <a
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ display: 'block', height: 18 }}
                        onClick={(event) => {
                            if (!event.isTrusted) {
                                event.preventDefault();
                            }
                        }}
                    >
                        {favicon &&
                            <img
                                src={favicon}
                                alt={`${title} favicon`}
                                style={{ height: '100%' }}
                            />
                        }
                    </a>
                </Tooltip>
            </Dropdown>
        </div>
    );
};

export default LinkAlert;

